import { createContext, useContext, useState, ReactNode } from "react";

interface FormContextType {
  isDirty: boolean;
  setIsDirty: (dirty: boolean) => void;
  resetDirty: () => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

interface FormProviderProps {
  children: ReactNode;
}

export function FormProvider({ children }: FormProviderProps) {
  const [isDirty, setIsDirty] = useState(false);

  const resetDirty = () => {
    setIsDirty(false);
  };

  return (
    <FormContext.Provider value={{ isDirty, setIsDirty, resetDirty }}>
      {children}
    </FormContext.Provider>
  );
}

export function useFormContext() {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
}
